<template>
  <div class="orderOverStyle">
    <top-component></top-component>
    <div class="orderContent">
      <el-tabs @tab-click="tabHandleClick" style="margin:20px  auto; ">
          <el-tab-pane label="图采会订单查询">
            <div class="dd">
                <div class="export_all">
                    <Button size="small" type="primary" @click="exportOrder()">批量导出订单</Button>
                    <Button size="small" v-if="adminState == '1'|| adminState == '0' " type="success" @click="exportAllOrder()">导出机构下所有订单</Button>
                    <Button size="small" type="danger" @click="handleCommand()">订单导入</Button>
                </div>
                <el-table :data="tableData" style="width: 100%;margin-top: 15px;" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="48"></el-table-column>
                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="订单日期" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="customOrderId" label="订单编号" width="180" align="center">
                    </el-table-column>
                    <el-table-column prop="goodsType" label="订单类型" align="center" width="100">
                    <template slot-scope="scope">
                        <span v-if="Number(scope.row.goodsType) === 1">纸质书</span>
                        <span v-else-if="Number(scope.row.goodsType) === 2">电子书</span>
                        <span v-else>非书籍</span>
                    </template>
                    </el-table-column>
                    <el-table-column prop="totalPrice" label="订单总价" align="right" width="100">
                    </el-table-column>
                    <el-table-column prop="submitter" label="加购人" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="操作人" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="300px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="DetailOrder(scope.row.orderId)">查看详情</el-link>
                        <el-link type="primary" @click="OrderDao(scope.row.orderId, 1)">导出订单</el-link>
                        <el-link type="primary" @click="OrderDao(scope.row.orderId, 2)">导出MARC</el-link>
                        <el-link type="primary" @click="balanceOrder(scope.row.orderId, 0)" v-if="scope.row.balance == 0">审核
                        </el-link>
                        <el-link type="primary" @click="balanceOrder(scope.row.orderId, 1)" v-if="scope.row.balance == 0">结算
                        </el-link>
                        <span style="color: #0fc50f;vertical-align: middle;" v-if="scope.row.balance == 1">已审核</span>
                        <span style="color: #ff0000;vertical-align: middle;" v-if="scope.row.balance == 1">已结算</span>
                    </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="pages.currentPage" :page-size="pages.pagesize" layout="prev, pager, next, jumper"
                    :total="pages.total">
                </el-pagination>
            </div>
          </el-tab-pane>
          <!-- <el-tab-pane label="荐购订单查询">
            <div class="jg">
                <el-table :data="tableData" style="width: 100%;margin-top: 15px;" @selection-change="handleSelectionChange">
                    <el-table-column type="selection" width="48"></el-table-column>
                    <el-table-column type="index" label="序号" width="50" align="center">
                    </el-table-column>
                    <el-table-column prop="createTime" label="订单日期" width="150" align="center">
                    </el-table-column>
                    <el-table-column prop="customOrderId" label="订单编号" width="160" align="center">
                    </el-table-column>
                    <el-table-column prop="goodsType" label="订单类型" align="center" width="80">
                    <template slot-scope="scope">
                        <span v-if="Number(scope.row.goodsType) === 1">纸质书</span>
                        <span v-else-if="Number(scope.row.goodsType) === 2">电子书</span>
                        <span v-else>非书籍</span>
                    </template>
                    </el-table-column>
                    <el-table-column prop="totalPrice" label="订单总价" align="right" width="80">
                    </el-table-column>
                    <el-table-column prop="submitter" label="加购人" width="80" align="center">
                    </el-table-column>
                    <el-table-column prop="submitter" label="收件人" width="80" align="center">
                    </el-table-column>
                    <el-table-column prop="submitter" label="收件号码" width="80" align="center">
                    </el-table-column>
                    <el-table-column prop="submitter" label="收件地址" width="80" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="操作人" width="100" align="center">
                    </el-table-column>
                    <el-table-column prop="name" label="操作" width="250px">
                    <template slot-scope="scope">
                        <el-link type="primary" @click="DetailOrder(scope.row.orderId)">查看详情</el-link>
                        <el-link type="primary" @click="dialogVisible = true">修改收货地址
                        </el-link>
                        <el-link type="primary" @click="progessVisible = true">物流信息
                        </el-link>
                        <span style="color: #0fc50f;vertical-align: middle;" v-if="scope.row.balance == 1">已审核</span>
                        <span style="color: #ff0000;vertical-align: middle;" v-if="scope.row.balance == 1">已结算</span>
                    </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
                    :current-page.sync="pages.currentPage" :page-size="pages.pagesize" layout="prev, pager, next, jumper"
                    :total="pages.total">
                </el-pagination>
                </div>
          </el-tab-pane> -->
          <!-- <el-tab-pane label="收货地址">
            <div class="address-form" v-if="tabIndex == 2"  style="margin:  50px auto;">
                <h2 style="margin-top: 20px; margin-bottom: 20px;">收货地址</h2>
                <form @submit.prevent="submitAddress" >
                    <div style="display: flex; align-items: center;  margin: 30px auto; justify-content: center;">
                    <label style="width: 150px;  margin-right: 20px;" for="district">省市区：</label>
                    <el-cascader size="medium " style="width: 500px;" :options="pcaTextArr" v-model="selectedOptions" @change="handleChange"> </el-cascader>
                    </div>
                    <div style="display: flex; align-items: center;  margin: 20px auto; justify-content: center;">
                    <label style="width: 150px; text-align: right; margin-right: 20px;" for="address">具体地址：</label>
                    <textarea id="address" style="width: 500px;" v-model="address"></textarea>
                    </div>
                    <div style="display: flex; align-items: center;  margin: 20px auto; justify-content: center;">
                    <button type="submit" @click="bcaddress" >保存地址</button>
                    </div>
                </form>
                </div>
          </el-tab-pane> -->
          <el-tab-pane label="书目下载" name="shumu">
            <div class="kj">
                <el-tabs v-model="booktab" type="card" @tab-click="booktypeHandleClick">
                    <el-tab-pane label="可供社科" name="2018020915511601905"></el-tab-pane>
                    <el-tab-pane label="可供科技" name="2018021014261407665"></el-tab-pane>
                    <el-tab-pane label="地方版社科" name="2019022510133116882"></el-tab-pane>
                    <el-tab-pane label="地方版科技" name="2019022510134016883"></el-tab-pane>
                </el-tabs>
                <el-table :data="bookList" style="width: 100%;margin-top: 15px;">
                    <el-table-column prop="listTitle" label="书目标题"></el-table-column>
                    <el-table-column prop="listPeriods" label="期数"></el-table-column>
                    <el-table-column prop="createDate" label="创建时间"></el-table-column>
                    <el-table-column prop="name" label="操作">
                        <template slot-scope="scope">
                        <el-link @click="downBook(scope.row)" >下载</el-link> 
                        </template>
                    </el-table-column>
                </el-table>
                <el-pagination @size-change="handleSizeChange2" @current-change="handleCurrentChange2" :current-page.sync="currentPage" :page-size="pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total"></el-pagination>
            </div>
          </el-tab-pane>
          
          <el-tab-pane label="统计分析">
            <div>
              <div style="display: flex; flex-wrap: wrap;" >
                <div ref="barChart" style="width: 580px; height: 400px;"></div>
                <div ref="barChart1" style="width: 620px; height: 400px;"></div>
              </div>
              <div style="display: flex; flex-wrap: wrap;" >
                <div ref="barChart2" style="width: 580px; height: 400px;"></div>
                <div ref="barChart3" style="width: 620px; height: 400px;"></div>
              </div>
              <div style="display: flex; flex-wrap: wrap;" >
                <div ref="barChart4" style="width: 580px; height: 400px;"></div>
                <div ref="barChart5" style="width: 620px; height: 400px;"></div>
              </div>
            </div>
          </el-tab-pane>
      </el-tabs>
      <!-- 图采会订单查询 -->
        
        
        <!-- 书目下载 -->
       
        
        <el-dialog
        title="收货地址"
        :visible.sync="dialogVisible"
        width="30%"
        :before-close="handleClose">
        <!-- 收货地址 -->
        <!-- <div class="address-form" style="margin:  50px auto;">
          <form @submit.prevent="submitAddress" >
            <div style="display: flex; align-items: center;  margin: 0px auto; justify-content: center; margin-bottom: 30px; ">
              <label style="width: 150px;  margin-right: 20px;" for="district">省市区：</label>
              <el-cascader size="medium " style="width: 500px;" :options="pcaTextArr" v-model="selectedOptions" @change="handleChange"> </el-cascader>
            </div>
            <div style="display: flex; align-items: center;  margin: 20px auto; justify-content: center;">
              <label style="width: 150px; text-align: right; margin-right: 20px;" for="address">具体地址：</label>
              <textarea id="address" style="width: 500px;" v-model="address"></textarea>
            </div>
            <div style="display: flex; align-items: center;  margin: 20px auto; justify-content: center;">
            <button type="submit" @click="bcaddress" >保存地址</button>
            </div>
          </form>
        </div> -->
       <!-- <span slot="footer" class="dialog-footer"> -->
       <!-- <el-button @click="dialogVisible = false">取 消</el-button>
       <el-button type="primary" @click="dialogVisible = false">确 定</el-button> -->
       </span>
       </el-dialog>
       <!-- 查看物流进度的对话框-->
    <el-dialog title="物流进度" :visible.sync="progessVisible" width="50%">
      <el-timeline>
        <el-timeline-item v-for="(activity, index) in progressInfo" :key="index" :timestamp="activity.time">
          {{ activity.context }}
        </el-timeline-item>
      </el-timeline>
    </el-dialog>
    </div>

    <bottom-component></bottom-component>
  </div>
</template>

<script>
  import {pcaTextArr} from "element-china-area-data";
  import TopComponent from '../Components/TopComponentcopy.vue'
  import BottomComponent from '../Components/BottomComponent.vue'
  import { listOrders, exportOrder, exportAllOrder, exportMarc, balanceOrder,publicationyearandmonthstatistics } from '@/api/pages'
  import Cookies from 'js-cookie'
  import FileSaver from 'file-saver';
  import * as echarts from 'echarts';
  import axios from 'axios';
  import { Button } from 'element-ui'
  export default {
    name: 'HelloWorld',
    data() {
      return {
        pcaTextArr,
        selectedOptions: [],
        dialogVisible: false,
        progessVisible:false,
        adminState: Cookies.get('adminState'),
        tabIndex: 0,
        pages: {
          currentPage: 1,
          pagesize: 10,
          total: 100
        },
        tableData: [],
        booktab: '2018020915511601905',
        bookList:[],
        currentPage: 1,
        pageSize: 20,
        total: 0,
        orderIdArr: [],
        progressInfo:[
          {
            time:"2024-04-09 12:39:56",
            ftime:"2024-04-09 12:39:56",
            context:"已签收,签收人是 汤小洋 先生/女士，如有疑问请联系派件员阿奇(13805148888)如您未收到此快递，请拨打投诉电话:15294207777，感谢使用申通快递，期待再次为您服务",
            location:null,
          },
          {
            time:"2024-04-08 08:46:54",
            ftime:"2024-04-08 08:46:54",
            context:"上海浦东寒亭营业厅-寒亭阿奇(13805148888)-派件中",
            location:null,
          },
          {
            time:"2024-04-08 08:38:57",
            ftime:"2024-04-08 08:38:57",
            context:"已到达-上海浦东寒亭营业厅",
            location:null,
          },
        ] 
      }
    },
    mounted() {
      this.ApiData()
      // 在组件挂载后初始化图表
      this.initBarChart();   //柱状图
      this.initBarChart2();   //折线图
      this.initBarChart3();   //饼状图
    },
    methods: {
        getBookList(){
            let vm = this;
            axios.post('/sxtucaihui/userlogin/action/bookorderlist', {
                groupGid: vm.booktab,
                page: vm.currentPage,
                rows: vm.pageSize,
            }).then(res => {
                if(res.status){
                    let resdata = JSON.parse(res.data.data);
                    vm.bookList = resdata.result.data;
                    vm.total = resdata.result.totalRecord;
                }
            }).catch(err => {

            });
        },
      booktypeHandleClick(tab, event){
        this.currentPage = 1;
        this.pageSize = 20;
        this.getBookList();
      },
      downBook(row){
         window.open('http://www.ytzhihui.com/ecp/down.download?filePath='+row.attachUrl, '_blank');
      },
      // 选择省市区
      handleChange(){
        console.log(this.selectedOptions,'selectedOptions');
      },
      //表格勾选
      handleSelectionChange(val) {
        let vm = this;
        vm.orderIdArr = [];
        val.forEach((ele, index) => {
          vm.orderIdArr.push(ele.orderId);
        });
      },
      exportOrder() {
        let vm = this;
        if (vm.orderIdArr.length > 0) {
          vm.OrderDao(vm.orderIdArr.join(), 1);
        } else {
          vm.$message({
            message: '至少选择一条订单数据才可批量导出！',
            type: 'warning'
          });
        }
      },
      tabHandleClick(tab, event) {
        let vm = this;
        vm.tabIndex = tab.index;
        vm.tableData = [];
        if(tab.name === 'shumu'){
            vm.getBookList();
        }else{
            vm.ApiData();
        }
      },
      handleCommand() {
        if (Cookies.get("token")) {
          this.$router.push({ name: "ImportOrder" });
        } else {
          this.$router.push({ name: "Login" });
        }
      },
      // 获取数据
      ApiData() {
        var obj = {
          userId: Cookies.get('UserID'),
          // currentIndex: this.pages.currentPage,
          pageNum: this.pages.currentPage,
          pageSize: this.pages.pagesize,
        }
        listOrders(obj).then(response => {
          this.tableData = response.data.list
          this.pages.total = response.data.total
        })
      },
      //结算
      balanceOrder(orderId, type) {
        let vm = this,
          str = '',
          obj = {
            orderId: orderId,
            balance: 1
          };
        type == 0 ? str = "审核通过" : str = "结算";
        vm.$confirm("确定要" + str + "吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          balanceOrder(obj).then(res => {
            if (res.status) {
              vm.$message({
                message: str + "成功！",
                type: 'success'
              });
              //刷新列表
              vm.ApiData();
            }
          });
        }).catch(() => { });
      },

      // 查看详情
      DetailOrder(orderId) {
        // console.log(orderId)
        this.$router.push({ name: 'OrderDetail', query: { orderId: orderId } })
      },
      async exportAllOrder() {
        axios.post('sxtucaihui/order/action/exportAllStream',
          {
            orgId: Cookies.get('orgGid')
          },
          { responseType: 'blob',
          headers: {
              'datasource':  Cookies.get('logintype'),
              'source':  Cookies.get('source'),

            }})
          .then(response => {
            const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
            FileSaver.saveAs(blob, '全部订单.xlsx');
            this.$message({
              message: "导出成功",
              type: "success",
              duration: 2000,
            });

          }).catch(error => {
            this.$message({
              message: "导出失败",
              type: "warning",
              duration: 2000,
            });
          });
      },

      // exportAllOrder(obj).then(response => {
      //   // console.log(response)
      //   window.location.href = response.data
      //   this.$message({
      //     message: '订单导出成功',
      //     type: 'success'
      //   })
      // })

      // 文件流下载
      async OrderDao(orderId, type) {
        if (type == 1) {
          axios.post('sxtucaihui/order/action/exportOrderStream',
            {
              orderId: orderId,
              userName: Cookies.get('name')
            },
            { responseType: 'blob',
            headers: {
              'datasource':  Cookies.get('logintype'),
              'source':  Cookies.get('source'),

            }}).then(response => {
              const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
              FileSaver.saveAs(blob, '订单汇总.xlsx');
              this.$message({
                message: "导出成功",
                type: "success",
                duration: 2000,
              });

            }).catch(error => {
              this.$message({
                message: "导出失败",
                type: "warning",
                duration: 2000,
              });
            });
        } else {
          axios.post('sxtucaihui/order/action/exportMarcStream',
            {
              orderId: orderId,
              userName: Cookies.get('name')
            },
            { responseType: 'blob',
            headers: {
              'datasource':  Cookies.get('logintype'),
              'source':  Cookies.get('source'),

            }
          })
            .then(response => {
              const blob = new Blob([response.data], { type: 'text/plain;charset=utf-8' });
              FileSaver.saveAs(blob, 'MARC.iso');
              this.$message({
                message: "导出成功",
                type: "success",
                duration: 2000,
              });

            }).catch(error => {
              this.$message({
                message: "导出失败",
                type: "warning",
                duration: 2000,
              });
            });
        }




      },
      handleClose(done) {
        this.$confirm('确认关闭？')
          .then(_ => {
            done();
          })
          .catch(_ => {});
      },
      bcaddress(){
        this.$message({
                message: "保存成功！",
                type: "warning",
                duration: 2000,
              });
      },
      xgaddress(){
        this.dialogVisible = false
        this.$message({
                message: "修改成功！",
                type: "warning",
                duration: 2000,
              });
      },
      async initBarChart() {
        // 初始化柱状图
        let barChart = echarts.init(this.$refs.barChart);
        let barChart1 = echarts.init(this.$refs.barChart1);
        let obj = {
          name: "cbny",
          orgid: Cookies.get('orgGid')
        }
         let res = await publicationyearandmonthstatistics (obj)
         console.log(res,'resss');
         if(res.code == '200'){
          this.initBarChartdata = res.data
          if(this.initBarChartdata.length >0){
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return item.total;
        });
        var seriesData1 = this.initBarChartdata.map(function (item) {
            return item.totalPrice;
        });
         }
         }
       
        let barOption = {
          title: {
            text: '出版年月统计(册)',
            left: 'center'
          },
          tooltip: {},
          xAxis: {
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: seriesData,
                type: 'bar',
                name: '册数',
            }]
        };
        let barOption1 = {
          title: {
            text: '出版年月统计(码洋)',
            left: 'center'
          },
          tooltip: {},
          xAxis: {
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: seriesData1,
                type: 'bar',
                name: '码洋',
            }]
        };
        // 使用指定的配置项和数据显示图表
        barChart.setOption(barOption);
        barChart1.setOption(barOption1);
      },
      async initBarChart2() {
        // 初始化柱状图
        let lineChart2 = echarts.init(this.$refs.barChart2);
        let lineChart3 = echarts.init(this.$refs.barChart3);

        let obj = {
          name: "ztf",
          orgid: Cookies.get('orgGid')
        }
         let res = await publicationyearandmonthstatistics (obj)
         if(res.code == '200'){
          this.initBarChartdata = res.data
          if(this.initBarChartdata.length >0){
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return item.total;
        });
        var seriesData1 = this.initBarChartdata.map(function (item) {
            return item.totalPrice;
        });
         }
          console.log(res,'ressss'); 
         }
         let lineOption1 = {
          title: {
            text: '学科专业(册)',
            left: 'center'
          },
          tooltip: {},
          xAxis: {
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: seriesData,
                type: 'line',
                name: '册数',
            }]
        };
        let lineOption2 = {
          title: {
            text: '学科专业(码洋)',
            left: 'center'
          },
          tooltip: {},
          xAxis: {
                type: 'category',
                data: xAxisData
            },
            yAxis: {
                type: 'value'
            },
            series: [{
                data: seriesData1,
                type: 'line',
                name: '码洋',
            }]
        };
        // 使用指定的配置项和数据显示图表
        lineChart2.setOption(lineOption1);
        lineChart3.setOption(lineOption2);
      },
      async initBarChart3() {
        // 初始化柱状图
        let lineChart2 = echarts.init(this.$refs.barChart4);
        let lineChart3 = echarts.init(this.$refs.barChart5);

        let obj = {
          name: "username",
          orgid: Cookies.get('orgGid')
        }
         let res = await publicationyearandmonthstatistics (obj)
         if(res.code == '200'){
          this.initBarChartdata = res.data
          if(this.initBarChartdata.length >0){
          var xAxisData = this.initBarChartdata.map(function (item) {
            return item.name;
          });
          var seriesData = this.initBarChartdata.map(function (item) {
            return {value:item.total,name:item.name};
        });
        var seriesData1 = this.initBarChartdata.map(function (item) {
            return {value:item.totalPrice,name:item.name};
        });
         }
          console.log(res,'ressss'); 
         }
         let lineOption1 = {
          title: {
            text: '荐购(数量)',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
          },
        
            series: [{
                data: seriesData,
                type: 'pie',
                name: '册数',
            }]
        };
        let lineOption2 = {
          title: {
            text: '荐购(码洋)',
            left: 'center'
          },
          tooltip: {
            trigger: 'item'
            // formatter: '{a} <br/>{b}: {c} ({d}%)'
          },
         
            series: [{
                data: seriesData1,
                type: 'pie',
                name: '码洋',
            }]
        };
        // 使用指定的配置项和数据显示图表
        lineChart2.setOption(lineOption1);
        lineChart3.setOption(lineOption2);
      },
      // 导出
      // OrderDao(orderId, type) {
      //   var obj = {
      //     orderId: orderId,
      //     userName: Cookies.get('name')
      //   }
      //   if (type === 1) {
      //     exportOrder(obj).then(response => {
      //       // console.log(response)
      //       window.location.href = response.data
      //       this.$message({
      //         message: '订单导出成功',
      //         type: 'success'
      //       })
      //     })
      //   } else {
      //     exportMarc(obj).then(response => {
      //       this.$message({
      //         message: 'MARC导出成功',
      //         type: 'success'
      //       })
      //       // console.log(response)
      //       window.location.href = response.data
      //     })
      //   }
      // },
      // 分页
      handleSizeChange(val) {
        console.log(`每页 ${val} 条`)
      },
      handleCurrentChange(val) {
        console.log(`当前页: ${val}`)
        this.pages.currentPage = val
        this.ApiData()
      },
      handleSizeChange2(val) {
        console.log(`每页 ${val} 条`)
        this.pageSize = val;
        this.getBookList();
      },
      handleCurrentChange2(val) {
        console.log(`当前页: ${val}`)
        this.currentPage = val
        this.getBookList()
      }
    },
    components: { TopComponent, BottomComponent, Button }
  }
</script>

<style scoped lang="scss">
  .orderOverStyle {
    width: 100%;
    background-color: #f9f9f9;
    overflow-x: hidden;
  }

  .orderContent {
    width: 1250px;
    /* display: flex; */
    margin-left: calc(50% - 600px);

    .export_all {
      padding: 10px;
      margin-top: 15px;
      background-color: #fff;
    }

    .orderChange {
      height: 60px;
      width: 1200px;
      margin: 30px auto 20px auto;
    }
  }

  .orderTitle {
    height: 40px;
    display: flex;
    align-items: center;
    margin-left: 30px;
    padding-top: 30px;
  }


  .address-form {
  max-width: 400px;
  margin: auto;
}
.address-form label {
  display: block;
  margin-bottom: 5px;
}
.address-form select,
.address-form textarea {
  width: 100%;
  padding: 8px;
  margin-bottom: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
}
.address-form button {
  padding: 10px 20px;
  background-color: #007bff;
  color: #fff;
  border: none;
  border-radius: 5px;
  cursor: pointer;
}
.address-form button:hover {
  background-color: #0056b3;
}
</style>


// WEBPACK FOOTER //
// src/views/ChildPages/Order-Over.vue